import { render } from "./EventSidebar.vue?vue&type=template&id=0f4ebb92&scoped=true"
import script from "./EventSidebar.vue?vue&type=script&lang=js"
export * from "./EventSidebar.vue?vue&type=script&lang=js"

import "./EventSidebar.vue?vue&type=style&index=0&id=0f4ebb92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4ebb92"]])

export default __exports__